const cleanPlaceName = (location) => String(
    location?.place_name ?? location?.placeName ?? '',
).trim();

export const isMapPinLocation = (location) => {
    const value = location?.is_map_pin ?? location?.isMapPin;
    return value === true || value === 1 || value === '1';
};

const coordinateValue = (value) => (
    value == null || value === '' ? '' : value
);

export const appendPickupLocationFormData = (
    formData,
    prefix,
    location = {},
    {includeContacts = true} = {},
) => {
    formData.append(`${prefix}[address]`, location.address || '');
    formData.append(`${prefix}[place_name]`, cleanPlaceName(location));
    formData.append(`${prefix}[latitude]`, coordinateValue(location.latitude));
    formData.append(`${prefix}[longitude]`, coordinateValue(location.longitude));
    formData.append(`${prefix}[is_map_pin]`, isMapPinLocation(location) ? '1' : '0');

    if (includeContacts) {
        formData.append(`${prefix}[contact_name]`, location.contact_name || '');
        formData.append(`${prefix}[contact_phone]`, location.contact_phone || '');
    }
};
